import { z } from "zod";
import { defineEvent } from "./registry.js";
/**
 * Platform yönetimi olayları (Prompt 24, ADR 0024 §21). Yük KİŞİSEL VERİ TAŞIMAZ. Kiracıyı ilgilendirenler kiracı odasına
 * gider (salt okunur bandı, destek erişimi bandı, abonelik ekranı canlı tazelenir); dışa aktarım isteği worker'da işlenir.
 */
const tenantStatus = z.enum(["TRIAL", "ACTIVE", "SUSPENDED", "READ_ONLY", "CLOSED"]);
export const platformTenantStatusChangedV1 = defineEvent({
    type: "platform.tenant.status_changed",
    version: 1,
    description: "Kiracının durumu değişti (askı, salt okunur, etkin, kapalı)",
    realtime: ["tenant"],
    payload: z.object({
        tenantId: z.uuid(),
        fromStatus: tenantStatus,
        toStatus: tenantStatus,
        cause: z.enum(["MANUAL", "BILLING", "CLOSURE"]),
    }),
});
export const platformSubscriptionChangedV1 = defineEvent({
    type: "platform.subscription.changed",
    version: 1,
    description: "Abonelik değişti (plan, dönem, durum, indirim)",
    realtime: ["tenant"],
    payload: z.object({
        tenantId: z.uuid(),
        status: z.enum(["TRIAL", "ACTIVE", "PAST_DUE", "SUSPENDED", "CANCELLED"]),
        planCode: z.string(),
    }),
});
export const platformInvoiceIssuedV1 = defineEvent({
    type: "platform.invoice.issued",
    version: 1,
    description: "Kiracıya platform faturası kesildi",
    realtime: ["tenant"],
    payload: z.object({
        tenantId: z.uuid(),
        invoiceId: z.uuid(),
        periodStart: z.iso.date(),
        periodEnd: z.iso.date(),
    }),
});
export const platformSupportAccessChangedV1 = defineEvent({
    type: "platform.support_access.changed",
    version: 1,
    description: "Destek erişimi istendi, onaylandı, reddedildi, iptal edildi ya da bitti",
    realtime: ["tenant"],
    payload: z.object({
        tenantId: z.uuid(),
        grantId: z.uuid(),
        status: z.enum(["REQUESTED", "ACTIVE", "DENIED", "REVOKED", "EXPIRED", "CANCELLED"]),
    }),
});
export const platformDataExportRequestedV1 = defineEvent({
    type: "platform.data_export.requested",
    version: 1,
    description: "Kiracı verisinin dışa aktarımı istendi (worker ZIP üretir)",
    realtime: [],
    payload: z.object({ tenantId: z.uuid(), exportId: z.uuid() }),
});
export const platformAnnouncementPublishedV1 = defineEvent({
    type: "platform.announcement.published",
    version: 1,
    description: "Duyuru / sürüm notu yayımlandı",
    realtime: [],
    payload: z.object({ announcementId: z.uuid(), severity: z.enum(["INFO", "IMPORTANT"]) }),
});
//# sourceMappingURL=platform.v1.js.map